import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [],total:0,error: "", message: "" }


export const pendingEarningClearAction = createAsyncThunk(
    'pending-earning-Clear',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/clear-pending`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const clearPendingEarningSlice = createSlice({
    name: 'pending-earning-Clear',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(pendingEarningClearAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(pendingEarningClearAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData
            })
            builder.addCase(pendingEarningClearAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData

            })
        },

})



export const clearPendingEarningReducer = clearPendingEarningSlice.reducer